module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "grid wrapper animation animation--delayed"
  }, [_c('items', {
    staticClass: "masonry",
    attrs: {
      "items": _vm.items
    }
  })], 1), _vm._v(" "), _c('instagram')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa2d1fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 314
// module chunks = 0